import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Audios from "../../assets/svg/musicIcon.svg";
import Contacts from "../../assets/svg/contactImage.svg";
import Document from "../../assets/svg/documentIcon.svg";
import Image from "../../assets/svg/imageLogoIcon.svg";
import Videos from "../../assets/svg/vedioIcon.svg";
import {
  getFileCount,
  getTotalVolume,
  getDirectory,
} from "../../redux/action/file";
import CardDetail from "./Card";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MediaCards = () => {
  const { t } = useTranslation();
  const { file_type, total_volume } = useSelector((state) => state.fileSlice);
  const [filesData, setFilesData] = useState([]);
  const volume = parseFloat(total_volume).toFixed(2);
  const navigate = useNavigate();

  const cardOrder = ["images", "videos", "audios", "docs", "contacts"];

  const updateArray = (arr) => {
    const mappedArray = arr?.map((item) => {
      let icon, bgColor;

      switch (item.name) {
        case "audios":
          icon = Audios;
          bgColor = "#8BC34A";
          break;
        case "contacts":
          icon = Contacts;
          bgColor = "#E74C3C";
          break;
        case "docs":
          icon = Document;
          bgColor = "#4CAF50";
          break;
        case "images":
          icon = Image;
          bgColor = "#FF6B35";
          break;
        case "videos":
          icon = Videos;
          bgColor = "#4A90E2";
          break;
        default:
          icon = null;
          bgColor = "#999";
      }

      return {
        ...item,
        icon,
        bgColor,
        displayName: t(`label.${item.name}`),
      };
    });

    return mappedArray?.sort((a, b) => {
      const indexA = cardOrder.indexOf(a.name);
      const indexB = cardOrder.indexOf(b.name);
      return indexA - indexB;
    });
  };

  useEffect(() => {
    getFileCount();
    getTotalVolume();
  }, []);

  useEffect(() => {
    setFilesData(updateArray(file_type));
  }, [file_type, t]);

  // ✅ async handler for card click
  const handleCardClick = async (name) => {
    try {
      const fileName = name?.toLowerCase();
      await getDirectory(fileName); // ✅ API call
      navigate(`/cloud/${fileName}`); // ✅ Navigate on success
    } catch (error) {
      console.error("Error fetching directory:", error);
      // Optionally show a toast or error message
    }
  };

  return (
    <div className="media-cards-container">
      <div className="cards-container">
        {filesData?.map((data) => (
          <div
            key={data.name}
            onClick={() => handleCardClick(data.name)}
            style={{ cursor: "pointer" }}
          >
            <CardDetail {...data} name={data.displayName} count={data.count} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MediaCards;
